import { Component, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { GlobalService } from "./common/globals";
import { Storage } from "@ionic/storage-angular";
import { AlertController, NavController, Platform } from "@ionic/angular";
import { AZUtils } from "./common/utils";
import { TranslateConfigService } from "./translate-config.service";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { TranslateService } from "@ngx-translate/core";
// import { WonderPush } from "@awesome-cordova-plugins/wonderpush/ngx";
import { AnalyticsService } from "./services/analytics/analytics.service";
import { filter } from "rxjs/operators";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import packageJson from "../../package.json";
import { LocationAccuracy } from "@ionic-native/location-accuracy/ngx";
import { Geolocation } from "@awesome-cordova-plugins/geolocation/ngx";
import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";
import { DeviceFingerprinterService } from "./device-fingerprinter.service";
import { showCategoryHeadTcbMenu as canShowCategoryHeadTcbMenu } from "./common/tcb-ch-approval.logic";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  fingerprint: string | undefined;
  entropy: { components: Record<string, any>; entropyBits: number } | undefined;

  public version: string = packageJson.version;
  checkingForUpdates = false;

  showBtn: boolean = false;
  selectedLanguage: string;
  current_user: any = {};
  muserdata: any = [];

  doLogout = async () => {
    // Track logout event
    await this.analyticsService.logEvent("logout", {
      user_id: this.mglobals.muser_id,
      user_email: this.mglobals.muser_email,
    });

    this.clearGlobalVariables();
    this.storage.remove("agrizy_token");
    this.storage.remove("finTech_token");
    this.storage.remove("agrizy_session_key");
    this.storage.remove("finTech_session_key");
    this.storage.remove("user_obj");
    this.navCtrl.navigateRoot(["./login"]);
  };

  clearGlobalVariables() {
    // Clear user-related global variables
    this.mglobals.muser_obj = {};
    this.mglobals.muser_logged_in = false;
    this.mglobals.agrizy_token = "";
    this.mglobals.agrizy_session_key = "";
    this.mglobals.muser_id = "";
    this.mglobals.muser_email = "";
    this.mglobals.muser_fname = "";
    this.mglobals.muser_lname = "";
    this.mglobals.mcomp_name = "";
    this.mglobals.mcomp_dname = "";
    this.mglobals.mcomp_key = "";
    this.mglobals.muser_type_id = 0;
    this.mglobals.mflag_admin = false;
    this.mglobals.mflag_agrizy_employee = false;
    this.mglobals.mflag_kyc_veri = false;
    this.mglobals.mflag_impersonate = false;
    this.mglobals.mimpersonate_user_id = "";
    this.mglobals.mimpersonate_log_id = "";
    this.mglobals.mcust_id = "";
    this.mglobals.muser_mobile_isd = "";
    this.mglobals.muser_mobile_no = "";
    this.mglobals.mses_key = "";
    this.mglobals.mflag_crea_cust = false;
    this.mglobals.mflag_ipm_access_rm = false;
    this.mglobals.mflag_ipm_access_admin = false;
    this.mglobals.mflag_ipm_and_trading_access_rm = false;
    this.mglobals.mflag_tcb_access_trade_direct = false;
    this.mglobals.mflag_tcb_access_trade_fintech = false;
    this.mglobals.mflag_tcb_category_head_approval = false;
    this.mglobals.mflag_fintech_access_rm = false;
    this.mglobals.finTech_token = "";
    this.mglobals.finTech_session_key = "";
    this.mglobals.mft_user_id = "";
    this.mglobals.mflag_early_pmt_release = false;
    this.mglobals.mflag_supplier_early_pmt_rm_auth = false;
    this.mglobals.mflag_early_pmt_restriction = false;
    this.mglobals.mft_company_details = {};
    this.mglobals.mft_buyer_list = [];
    this.mglobals.mbuyer_tcb = {};
    this.mglobals.mbuyer_tcb_materials = [];
    this.mglobals.mbuyer_tcb_pmt_terms = {};
    this.mglobals.msupplier_tcb = [];
    this.mglobals.msupplier_tcb_materials = [];
    this.mglobals.msupplier_tcb_pmt_terms = {};
  }

  constructor(
    private translate: TranslateService,
    private translateConfigService: TranslateConfigService,
    public mglobals: GlobalService,
    private storage: Storage,
    public navCtrl: NavController,
    public platform: Platform,
    public mutils: AZUtils,
    private router: Router,
    // private wonderPush: WonderPush,
    private alertController: AlertController,
    private analyticsService: AnalyticsService,
    private locationAccuracy: LocationAccuracy,
    private geolocation: Geolocation,
    private fingerprinterService: DeviceFingerprinterService,
    private splashScreen: SplashScreen,
  ) {
    this.initializeApp();
    this.setupScreenTracking();

    this.mglobals.magrizy_fin_tech;
    this.getLocation();
    this.getDeviceId();
  }

  requestToSwitchOnGPS() {
    this.locationAccuracy
      .request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY)
      .then(
        () => {
          this.getLocation();
        },
        (error) => alert(JSON.stringify(error)),
      );
  }

  // Customer Current Lat & Long
  async getLocation() {
    this.geolocation
      .getCurrentPosition()
      .then((position) => {})
      .catch((error) => {
        this.mutils.presentToast("Kindly allow location access");
        console.log("Error getting location", error);
      });
  }

  async getDeviceId() {
    const info = await Device.getId();
    // console.log('Device ID:', info.identifier);

    this.fingerprint = await this.fingerprinterService.generateFingerprint();
    // console.log('Device Fingerprint:', this.fingerprint);

    this.entropy = await this.fingerprinterService.getFingerprintEntropy();
    // console.log('Fingerprint Components:', this.entropy.components);
    // console.log('Estimated Entropy Bits:', this.entropy.entropyBits);
  }

  /**
   * Sets up automatic screen tracking for route changes
   */
  private setupScreenTracking() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Get the current route path
        let route = event.urlAfterRedirects || "/";

        // Remove query parameters and hashes
        const path = route.split("?")[0].split("#")[0];

        // Get the last part of the URL as the screen name
        const screenName = path.split("/").pop() || "home";

        // Format the screen name to be more readable
        const formattedScreenName = this.formatScreenName(screenName);

        // Track the screen view
        this.analyticsService.trackScreenView(
          formattedScreenName,
          formattedScreenName,
        );
      });
  }

  private formatScreenName(name: string): string {
    if (!name) return "Home";
    // Replace hyphens and underscores with spaces
    return name
      .split(/[-_]+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  showCategoryHeadTcbMenu(): boolean {
    return canShowCategoryHeadTcbMenu(this.mglobals);
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: "Are you sure you want to Logout?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
        },
        {
          text: "Yes",
          role: "confirm",
          handler: () => {
            this.doLogout();
          },
        },
      ],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }

  async exitImpersonation() {
    try {
      let m_imp_user_id = this.mglobals.mimpersonate_user_id;
      let m_imp_log_id = this.mglobals.mimpersonate_log_id;
      const impersonateData = {
        impersonate_user_id: m_imp_user_id,
        impersonate_log_id: m_imp_log_id,
      };
      const mxdata = await this.mutils.postData(
        "exitImpersonation",
        impersonateData,
      );
      if (mxdata && mxdata.header.status == 1) {
        this.mutils.presentToast("Exited From Customer Profile");
        await this.storage.set("user_id", mxdata.body.data.user_id);
        this.storage.set("user_obj", mxdata.body.data).then(() => {
          this.mutils.setSessionData();
        });
        await this.storage.set("agrizy_token", mxdata.body.data.token);
        this.mglobals.agrizy_token = mxdata.body.data.token;
        this.navCtrl.navigateRoot(
          "/customer-details/" + this.mglobals.mcust_id,
        );
      } else {
        this.mutils.presentToast(mxdata.body.error.msg);
      }
    } catch (err) {
      console.log("Error: " + err);
    }
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      // Initialize Analytics Service
      await this.analyticsService.init();

      // Test analytics functionality
      // await this.analyticsService.testAnalytics();

      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          // console.log(event);
          // Extract just the base path
          const screenName = event.urlAfterRedirects.split("/")[1] || "home";
          // console.log("Screen Name: ", screenName);
          this.analyticsService.trackScreenView(screenName);
        });
      // this.analyticsService.startTrackerWithId('G-FSL26MQ234');
      // this.wonderPush
      //   .subscribeToNotifications()
      //   .then(() => console.log("User subscribed to notifications"))
      //   .catch((error: any) => {
      //     console.error("Error subscribing to notifications:", error);
      //   });
      // Tell Capgo the app is ready only after platform is ready (native only)
      if (Capacitor.isNativePlatform()) {
        try {
          CapacitorUpdater.notifyAppReady();
        } catch (e) {
          console.warn("CapacitorUpdater.notifyAppReady failed", e);
        }
      }
      // Hide native splash (launchAutoHide is false in config)
      this.splashScreen.hide();
    });

    await this.storage.create();
    this.storage.get("device_id").then(async (res) => {
      var mdevice_id = "";
      if (res == null) {
        mdevice_id = this.mutils.getUUID();
        await this.storage.set("device_id", mdevice_id);
      } else {
        mdevice_id = res;
      }
      // this.wonderPush.setProperty("device_id", mdevice_id);
      this.mglobals.mdevice_id = mdevice_id;
      this.storage.get("agrizy_session_key").then(async (val) => {
        var magrizy_session_key = val;
        this.storage.get("agrizy_token").then(async (tokenVal) => {
          var magrizy_token = tokenVal;
          if (magrizy_session_key == null) {
            this.mglobals.muser_logged_in = false;
            this.mglobals.muser_obj = null;
            this.mglobals.agrizy_session_key = "";
            this.mglobals.agrizy_token = "";
            this.navCtrl.navigateRoot("/select-language");
          } else {
            //Handshake
            this.mglobals.muser_logged_in = true;
            this.mglobals.agrizy_session_key = magrizy_session_key;
            this.mglobals.agrizy_token = magrizy_token || ""; // Set token if available
            await this.mutils.setSessionData();
            this.navCtrl.navigateRoot("/home");
            this.current_user = this.mglobals;
          }
        });
      });
    });
  }

  /**
   * Manual check for OTA updates (download + reload).
   * Not called from initializeApp: with autoUpdate: true, Capgo already checks on launch
   * and downloads in background; updates apply on background or next launch.
   */
  async checkForUpdates() {
    if (!this.platform.is("hybrid")) {
      this.mutils.presentToast("Updates are for the native app only");
      return;
    }
    if (this.checkingForUpdates) return;
    this.checkingForUpdates = true;
    try {
      const latest = await CapacitorUpdater.getLatest();
      if (!latest?.url) {
        this.mutils.presentToast("Already up to date");
        return;
      }
      this.mutils.presentToast("Downloading update...");
      const bundle = await CapacitorUpdater.download({
        url: latest.url,
        version: latest.version,
        checksum: latest.checksum,
        sessionKey: latest.sessionKey,
      });
      await CapacitorUpdater.next({ id: bundle.id });

      const alert = await this.alertController.create({
        header: "Update ready",
        message: `Version ${bundle.version} ready. Close the app from recent apps, then open it again.`,
        buttons: [
          {
            text: "Later",
            role: "cancel",
            handler: () => {
              // Update will apply on next app launch or when backgrounded
            },
          },
          {
            text: "OK",
            handler: () => {
              this.mutils.presentToast("Close the app from recent apps, then open it again.");
            },
          },
        ],
      });
      await alert.present();
    } catch (err: any) {
      const msg = err?.message || String(err);
      if (msg.includes("No new version") || msg.includes("no_new_version")) {
        this.mutils.presentToast("Already up to date");
      } else {
        this.mutils.presentToast(
          "Update check failed: " + (msg.slice(0, 50) || "Unknown error"),
        );
      }
    } finally {
      this.checkingForUpdates = false;
    }
  }

  @HostListener("window:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log('Key pressed:', event.key, 'Meta:', event.metaKey, 'Shift:', event.shiftKey);

    if (event.metaKey && event.key === "r") {
      event.preventDefault();
      // console.log('Command + R prevented');
      // alert('Reloading is disabled on this page!');
    }
    if (event.metaKey && event.shiftKey && event.key === "R") {
      event.preventDefault();
      // console.log('Command + Shift + R prevented');
      // alert('Hard reload is disabled!');
    }
    if (event.key === "F5") {
      event.preventDefault();
      // console.log('F5 prevented');
      // alert('Reloading is disabled!');
    }
  }
}
